require('./bootstrap');

// Importar o Inputmask
import Inputmask from "inputmask";
